import ExcelJS from 'exceljs';
import { UserModel } from '../../../app/modules/auth/models/UserModel';
import { ReportTerminType } from '../../../interfaces/ReportTermin';
import { IntlShape } from 'react-intl';
import { TableColumn } from 'react-data-table-component';
import { createWorkbook, createWorksheet, exportWorkbook, setColumnWidths } from './helperExportReportTermin';
import { CustomField } from '../../../interfaces/Settings';
import { formatCustomField, styleColumns } from '../../ExportTemplateExcel/helperTemplateExcel';
import { returnLeadProducts } from '../../general';


interface ExportExcelReportTerminProps {
    nameFile: string,
    source: string,
    nameHeader: any,
    param: any,
    intl: IntlShape,
    data: any[],
    columns: TableColumn<ReportTerminType>[],
    user: UserModel,
    dateStart?: any,
    dateEnd?: string,
    isFilterDate?: boolean,
    customFieldTermin: CustomField,
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
}

export const exportExcelReportTermin = async ({
    nameFile,
    source,
    nameHeader,
    param,
    intl,
    data,
    columns,
    user,
    customFieldTermin,
    setIsLoading,
}: ExportExcelReportTerminProps) => {
    let exportData: any[] = [];
    const workbook = createWorkbook();
    const worksheet = createWorksheet(workbook, source);

    Array.from(data).forEach((row: any) => {
        let temp_excel = [];
        temp_excel.push(
            row.merchantName,
            returnLeadProducts(row.leadProducts),
            row.terminNominal,
            row.tanggalJatuhTempo,
            row.tanggalPembayaran || '-',
        );

        Object.keys(customFieldTermin).forEach((field) => {
            const type = customFieldTermin[field].type;
            const formattedField = formatCustomField(row, field, type, user!, 'reportTermin');
            temp_excel.push(formattedField);
        });
        exportData.push(temp_excel);
    });

    const returnSubHeader = () => {
        return Object.keys(customFieldTermin).map((field: any) => {
            if (customFieldTermin[field].type === 'date') return 'Format (YYYY-MM-DD)'
            else if (customFieldTermin[field].type === 'dateTime') return 'Format (YYYY-MM-DD HH:mm)'
            else if (customFieldTermin[field].type === 'dateTimeRange') return 'Format (YYYY-MM-DD HH:mm - YYY-MM-DD HH:mm)'
            else if (customFieldTermin[field].type === 'time') return 'Format (HH:mm)'
            else return ''
        })
    }

    var header = [...nameHeader.reportTermin.header, ...Object.keys(customFieldTermin).map((field: any) => customFieldTermin[field].name)]
    var subHeader = [...nameHeader.reportTermin.subHeader, ...returnSubHeader()]

    worksheet.getRow(1).values = header
    worksheet.getRow(2).values = subHeader

    addDataRows(worksheet, exportData, customFieldTermin);
    setColumnWidths(worksheet, source, customFieldTermin, exportData);
    styleColumns(worksheet, source, 1);
    styleColumns(worksheet, source, 2);

    exportWorkbook(workbook, source, `${nameFile}.xlsx`);
};

const addDataRows = (
    worksheet: ExcelJS.Worksheet,
    data: any[],
    customFields: CustomField
) => {
    data.forEach((rowData, index) => {
        const row = worksheet.addRow(rowData);

        const numberColumns = [3]; // terminNominal column

        row.eachCell((cell, colIndex) => {
            cell.alignment = {
                vertical: 'top',
                wrapText: true,
                shrinkToFit: true,
            };

            if (colIndex === 2) {
                cell.alignment = {
                    vertical: 'top',
                    wrapText: true,
                    horizontal: 'left'
                };
            }

            if (numberColumns.includes(colIndex)) {
                cell.numFmt = '#,##0;[Red]-#,##0';
            }

            const offsetColumns = 8;
            if (colIndex > offsetColumns) {
                const fieldIndex = colIndex - offsetColumns - 1;
                const fieldId = Object.keys(customFields)[fieldIndex];
                if (fieldId && customFields[fieldId].type === 'number') {
                    cell.numFmt = '#,##0;[Red]-#,##0';
                }
            }
        });
    });
}
